/*
 *
 * # Example of usage:
 *
 * 1 - Using all props
 * <DateRangePicker beginDate={"1452-04-15"} endDate={"1519-05-02"} handleSelection={function() { console.log("Date selected");}}/>
 *
 *
 */

"use strict";

var cx = require("classnames");
var moment = require("moment");

var DateRangePicker = React.createClass({
  propTypes: {
    inputWidth: React.PropTypes.string,
    inputBeginDateId: React.PropTypes.string,
    inputEndDateId: React.PropTypes.string,
    beginDate: React.PropTypes.string.isRequired, /* Format: YYYY-MM-DD */
    endDate: React.PropTypes.string.isRequired, /* Format: YYYY-MM-DD */
    handleSelection: React.PropTypes.func.isRequired,
    readOnly: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      inputWidth: "85px",
      inputPadding: "3px",
      inputBeginDateId: "beginDate",
      inputEndDateId: "endDate",
      readOnly: true
    };
  },

  componentDidMount: function() {
    this.startDatepicker();
  },

  componentWillUpdate: function() {
    this.startDatepicker();
  },

  startDatepicker: function() {
    $(`#${this.props.inputBeginDateId}, #${this.props.inputEndDateId}`).datepicker({
      dateFormat:"dd M, yy",
      onSelect: function(dateText, inst) {
        this.props.handleSelection(dateText, inst);
        $(this).datepicker("hide").blur();
      }.bind(this)
    });

    $("#ui-datepicker-div").on("click", function(e) {
      e.stopPropagation();
    });
  },

  render: function () {
    var inputClassName = cx("form-control", "bg-white");
    var labelClassName = cx("ml-10", "mr-10");
    moment.locale('pt-BR');
    var beginDateFormatted = moment(this.props.beginDate).format("DD MMM, YYYY");
    var endDateFormatted = moment(this.props.endDate).format("DD MMM, YYYY");
    var wrapperClassName = cx("d-f", "align-center", this.props.className)

    return (
      <div className={wrapperClassName}>
        <input type="text" style={{width: this.props.inputWidth}} className={inputClassName}  defaultValue={beginDateFormatted} id={this.props.inputBeginDateId} spellCheck="false" readOnly={this.props.readOnly}/>
        <span className={labelClassName}>até</span>
        <input type="text" style={{width: this.props.inputWidth}} className={inputClassName} defaultValue={endDateFormatted} id={this.props.inputEndDateId} spellCheck="false" readOnly={this.props.readOnly}/>
      </div>
    );
  }
});
module.exports = DateRangePicker;



// WEBPACK FOOTER //
// ./app/shared/components/DateRangePicker/date-range-picker.jsx